import * as React from 'react';
import { SVGProps } from 'react';

const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.789 3H5.684A1.69 1.69 0 0 0 4 4.684v11.789h1.684V4.684h10.105V3zm2.527 3.368H9.053a1.69 1.69 0 0 0-1.684 1.684v11.789a1.69 1.69 0 0 0 1.684 1.684h9.263A1.69 1.69 0 0 0 20 19.841V8.052a1.69 1.69 0 0 0-1.684-1.684zm0 13.474H9.053V8.053h9.263v11.789z" />
  </svg>
);

export default SvgCopy;
